import { Box, SxProps, Theme } from '@mui/material';

import { ErrorBoundary } from 'react-error-boundary';

import { ErrorFallback } from '../components/ErrorFallback';
import { SkipNavContent } from '../components/navigation/SkipNav';
import { NavigationProvider } from '../components/settings/components/navigation/NavigationContext';
import SettingsNavigation from '../components/settings/components/navigation/SettingsNavigation';
import { SettingsLayout as Settings } from '../components/settings/components/SettingsLayout';

const layoutSx: () => SxProps<Theme> = () => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  backgroundColor: (theme) => theme.palette.grey10,
  height: '100dvh',
  position: 'relative',
  overflow: 'hidden',
  outline: (theme: Theme) => `0.5px solid ${theme.palette.grey30}`,
  '@media (max-width: 900px)': {
    gridTemplateColumns: '1fr',
  },
});

export default function SettingsLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <Box sx={layoutSx()}>
      <NavigationProvider>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <SettingsNavigation />
        </ErrorBoundary>
        <Settings.Layout>
          <SkipNavContent />
          {children}
        </Settings.Layout>
      </NavigationProvider>
    </Box>
  );
}
